"use strict";
/*
Example:

```json
[
  {
    "days": [0,1],
    "start": "18:00",
    "end": "20:00",
    "type": "ALLOWANCE",
    "state": "CONTROLLED"
  }
]
```
*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./getTimezonedDate"), exports);
__exportStar(require("./filterTimetable"), exports);
__exportStar(require("./formatStartAndEndTime"), exports);
__exportStar(require("./getCurrentTimetableRules"), exports);
__exportStar(require("./isDateAllowedOnTimetable"), exports);
__exportStar(require("./getValidTimetableRulesByDay"), exports);
__exportStar(require("./sanitizeTimetableInput"), exports);
__exportStar(require("./schedule-selectors"), exports);
//# sourceMappingURL=index.js.map